import ajax from '@/utils/ajax';

export const head = '/web';

// C端书课学习考季列表
export const reqExamSeason = () => ajax(`${head}/v1/book-class/study/exam-season`);

// C端书课学习学科分类列表
export const reqSubject = (examSeason) => ajax(`${head}/v1/book-class/study/subject-list?examSeason=${examSeason}`);

// 根据id查询书课学习详情 （C端）
export const reqStudyDetail = (id) => ajax(`${head}/v1/book-class/study/front/${id}`);


// 
export const reqTeacherList = (teacherList,isDisciplineInfo) => ajax(`${head}/v1/teacher/batch?ids=${teacherList}&isDisciplineInfo=${isDisciplineInfo}`);
